import Coficoffre from "@/components/common/tools/coficoffre";

export default function CoficoffreView() {
  return <Coficoffre />;
}
